export class ApiResponse {
  constructor(
    private code: number,
    private success: boolean,
    private message: string,
    private data: any = null,
    private errors: any[] | null = null,
    private total: number | null = null,
  ) {
  }

  getCode(): number {
    return this.code;
  }

  isSuccess(): boolean {
    return this.success;
  }

  getMessage(): string {
    return this.message;
  }

  getData(): any {
    return this.data;
  }

  getTotal(): number {
    return this.total ?? 0;
  }

  getErrors(): any[] | null {
    return this.errors;
  }
}
